import { gql } from '@common/hooks';

export const BatchAddWorksMembershipsOrganizationUnitsQuery = gql`
  mutation BatchAddWorksMembershipsOrganizationUnits(
    $input: BatchAddWorksMembershipsOrganizationUnitsInput!
  ) {
    batchAddWorksMembershipsOrganizationUnits(input: $input) {
      worksMemberships {
        id
        organizationUnits {
          id
        }
      }
    }
  }
`;

export type BatchAddWorksMembershipsOrganizationUnitsResponse = {
  batchAddWorksMembershipsOrganizationUnits: {
    worksMemberships: {
      id: string;
      organizationUnits: {
        id: string;
      }[];
    }[];
  };
};

export type BatchAddWorksMembershipsOrganizationUnitsVariables = {
  input: {
    worksMembershipIds: string[];
    organizationUnitIds: string[];
  };
};
